import React, { Component } from 'react';
import { connect } from 'react-redux';
import {reduxForm} from 'redux-form';
import { Tab, Tabs } from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';
import DefaultSettings from './defaultSettings';
import DownloadClientList from './uploadExcel/downLoadClientList'
import { uploadBehavior, uploadNewTargets } from './uploadExcel/downloadTargets/actions/downloadTargetAction';
import UploadBehavior from './uploadExcel/downloadTargets/UploadBehavior';
import DownloadTargetsORBehaviorTab from './uploadExcel/downloadTargetsBehaviors/index';
import UploadRawData from './uploadExcel/uploadRawData';
import { uploadRawDataTarget, uploadRawDataBehavior } from './uploadExcel/uploadRawData/actions/downloadTargetAction';

const innerTabStyles = {
    default_tab: {
        height: '40px',
        fontSize: '14px',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.60)',
        border: '1px solid #ddd',
    },
    active_tab: {
        height: '37px',
        color: 'rgba(0, 0, 0, 0.80)',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
    },
};


class Settings extends Component {
     constructor(props) {
            super(props);
            this.state = {
                activeTab: 0,
                activeTabValue: '0',
                innerActiveTab: '0'
            }
        }

        componentDidMount(){

                if(!this.props.isDisabledDefaultSetting){

                    this.setState({activeTab: "1",activeTabValue:'1'})
                }
            
                if(!this.props.isDisabledUploadExcel){

                    this.setState({activeTab: "0",activeTabValue:'0'})
                }
        }
    

        setActive = (value) => {
            this.setState({ activeTab: value, activeTabValue: value });
        }

        setInnerActive=(value) =>{
            if (value === this.state.innerActiveTab) {
                return false;
            }
            this.setState({ innerActiveTab: value });
        }

        handleTabChange(value) {
            this.setState({ activeTabValue: value, activeTab: value });
        }

        renderSetupTabs = ()=>{
                let component = null;
                innerTabStyles.tab = [];
                innerTabStyles.tab[0] = innerTabStyles.default_tab;
                innerTabStyles.tab[1] = innerTabStyles.default_tab;
                innerTabStyles.tab[2] = innerTabStyles.default_tab;
                innerTabStyles.tab[3] = innerTabStyles.default_tab;
                innerTabStyles.tab[this.state.innerActiveTab] = innerTabStyles.active_tab;
                switch (this.state.innerActiveTab) {
                    case '0':
                        component = (<DownloadClientList patientId={this.state.patientId} location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                        break;
                    case '1':
                        component = (<UploadBehavior patientId={this.state.patientId} dialogTitle={"Upload New Targets"} title={"*Please download the template using the 'Download Client List' button on previous tab. Once filled, upload the bulk data using the option provided here."} location={this.props.location.pathname.split('/')} documentHandler={this.props.uploadNewTargets} uploadBehaviorHandler={this.props.uploadBehavior} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                        break;
                    case '2':
                        component = (<DownloadTargetsORBehaviorTab patientId={this.state.patientId}  location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} />);
                        break;    
                    case '3':
                        component = (<UploadRawData patientId={this.state.patientId} title={"*Please download the template using the Download Targets/Behaviors tab. Once filled, upload the bulk data using the option provided here."}  location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handleTabChange.bind(this)} uploadRawDataTarget={this.props.uploadRawDataTarget} uploadRawDataBehavior={this.props.uploadRawDataBehavior}/>);
                        break;
                    default:
                        component = null;
                        break;
                }
                return (
                    <div className="readmin-panel">
                        <div className="panel-body">
                            <div>
                                <Tabs className="custom_tabs secondary_tab">
                                    <Tab className="customtab" style={innerTabStyles.tab[0]}
                                        onClick={(e) => this.setInnerActive('0')}
                                        value={0}
                                        label={<font>Download Client List</font>}>
                                    </Tab>
                                    <Tab className="customtab" style={innerTabStyles.tab[1]}
                                        onClick={(e) => this.setInnerActive('1')}
                                        value={1}
                                        label={<font>Upload Targets/Behaviors</font>}>
                                    </Tab>
                                    <Tab className="customtab" style={innerTabStyles.tab[2]}
                                        onClick={(e) => this.setInnerActive('2')}
                                        value={1}
                                        label={<font>Download Targets/Behaviors</font>}>
                                    </Tab>
                                    <Tab className="customtab" style={innerTabStyles.tab[3]}
                                        onClick={(e) => this.setInnerActive('3')}
                                        value={1}
                                        label={<font>Upload Raw Data</font>}>
                                    </Tab>
                                </Tabs>
                                {component}
                            </div>
                        </div>
                    </div>
                );
            }
        
    
        render() {
            var styles = {
                default_tab: {
                    height: '50px',
                    fontSize: '13px',
                },
                active_tab: {
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.10)',
                    height: '48px',
                    fontSize: '13px',
                },
            };
            styles.tab = [];
            styles.tab[0] = styles.default_tab;
            styles.tab[1] = styles.default_tab;
            styles.tab[2] = styles.default_tab;
            styles.tab[3] = styles.default_tab;
            styles.tab[4] = styles.default_tab;
            styles.tab[5] = styles.default_tab;
            styles.tab[this.state.activeTab] = styles.active_tab;
            styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
            return (
                <div>
                    <h2 className="page_title">Settings</h2>
                    <div className="clearfix"></div>
                    <div className="readmin-panel">
                        <div className="panel-body">
                            <Tabs className="custom_tabs" value={this.state.activeTabValue} >
                                {
                                    (this.props.isDisabledDefaultSetting) && (
                                    <Tab
                                        onClick={(e) => this.setActive('0')}
                                        disabled={!this.props.isDisabledDefaultSetting}
                                        style={styles.tab[0]}
                                        value="0"
                                        className="customtab"
                                        icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                        label={<font>DEFAULT SETTINGS</font>}>
                                        {
                                            this.state.activeTabValue === '0' ?
                                                <DefaultSettings addPermission={this.props.addPermission}/> : ''
                                        }
                                    </Tab>       
                                    )
                                }
                                {
                                    ( this.props.isDisabledUploadExcel) && (
                                        <Tab
                                            disabled={!this.props.isDisabledUploadExcel}
                                            onClick={(e) => this.setActive('1')}
                                            style={styles.tab[1]}
                                            value="1"
                                            className="customtab"
                                            icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                            label={<font>UPLOAD EXCEL</font>}>
                                        {
                                                this.state.activeTabValue === '1'?this.renderSetupTabs():''
                                            }
                                            
                                        </Tab>
                                    )
                                }
                            </Tabs>
                        </div>
                    </div>
                </div>
            )
        }
}

Settings= reduxForm({
    form: 'SettingsForm',
})(Settings);

function mapStateToProps(state) {

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "MASTERS_DATA_COLLECTION");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "MASTERS_DATA_COLLECTION_SETTING" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_DEFAULT_SETTINGS")[0].permission : false;
    let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_DEFAULT_SETTINGS")[0].permission : false;
    let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_DEFAULT_SETTINGS")[0].permission : false;
    let isDisabledUploadExcel = hasDefaultAccess ? true : state.login.userPermission.actionPermissions ? state.login.userPermission.actionPermissions.find((obj) => {
        return obj.actionKey === "MASTERS_DATA_COLLECTION_UPLOAD_EXCEL"
    }).permission : false;
    let isDisabledDefaultSetting = hasDefaultAccess ? true : state.login.userPermission.actionPermissions ? state.login.userPermission.actionPermissions.find((obj) => {
        return obj.actionKey === "MASTERS_DATA_COLLECTION_DEFAULT_SETTINGS"
    }).permission : false;
    // End For Role Permission

    return {
        isDisabledUploadExcel:isDisabledUploadExcel,
        isDisabledDefaultSetting,
        loading: state.behaviorCategory.loading,
        addPermission: addPermission, // For Role Permission
        updatePermission: updatePermission, // For Role Permission
        deletePermission: deletePermission // For Role Permission
    }
}

export default connect(mapStateToProps, {uploadNewTargets, uploadBehavior, uploadRawDataTarget, uploadRawDataBehavior })(Settings);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/index.js